'use strict';

/* globals grecaptcha */

var Analytics = require('./analytics');

class AnalyticsManager extends Analytics {
    init () {
        super.init($('.analytics.navigationData'), $('.analytics.helperData'));

        this.analyticProviders = [
            require('./cartInteraction'),
            require('./checkoutFunnel'),
            require('./minicart'),
            require('./account'),
            require('./promoAndInfo'),
            require('./findYourStore'),
            require('./listing'),
            require('./refund'),
            require('./digitalWallet')
        ];

        for (let provider of this.analyticProviders) {
            provider.init(this.globalContainer, this.helperContainer);
        }

        this.pushPDPData();
        this.prepareHeaderObservers();
        this.prepareMenuObservers();
        this.prepareSearchObservers();
        this.prepareNewsletterObservers();
        this.observeWishlistChanges();
        this.handleContactUs();
        this.observeFooterChanges();
        this.observeProductChanges();
        this.observeVideoTracking();
        this.prepareRefinementsObservers();
        this.prepareScalaPayKlarnaObservers();
        this.observeSoldOutPopupChanges();
        this.prepareGiftcardObservers();
        this.observeOrderChanges();
        this.observeMadeInClick();
        this.handlePhoneUnsubscribe();
        this.handleSmartGift();
        this.handleRatingAndReviewsPdp();
        this.handleRatingAndReviewsForm();
        this.prepareNeedHelpObservers();
        this.prepareEcoChoiceObservers();
        this.prepareTrackYourOrderObservers();
        this.preparePersonalAreaNavigationOrderSectionObservers();
        this.prepareQuizBraObservers();
        this.cookiePolicyObservers();
        this.replaceTagsPrivacyConsentModal();
        this.prepareOrderAgainObservers();
    }

    handlePhoneUnsubscribe () {
        var _self = this;
        $('body').on('unsubscribeSmsAnalyticTrigger', function (e) {
            _self.quickImpressionSender.pushUnsubscribeSmsForm();
        });
    }

    getPDPInfo () {
        let container = $('.analytics.product');
        return container.data();
    }

    pushPDPData () {
        let container = $('.analytics.product');
        if (container.length === 0) {
            // We are not in PDP
            return;
        }

        const itemId = container.data('item_id');
        const visualizationKey = `visualizationTypeProduct${itemId}`;
        if (localStorage.getItem(visualizationKey)) {
            const visualizationType = localStorage.getItem(visualizationKey);
            container.data('visualization_type', visualizationType);
            container.attr('data-visualization_type', visualizationType);
        }

        const item = this.helper.formatProductForAnalytics(this.getPDPInfo());
        Object.assign(item, this.helper.getGtmData({
            item_id: item.item_id,
            item_variant: item.item_variant
        }));

        let pushObject = {
            event: 'view_item',
            ss_event_id: Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            ecommerce: {
                currency: this.helperData.currency,
                item_list_name: item.item_list_name,
                item_list_id: item.item_list_id,
                items: [item],
            },
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    getPLPProductInfo (pid) {
        let container = $(".product[data-pid='" + pid + "']").find('.analytics.productListingItem'); ;
        return container.data();
    }

    getSkuFromHtmlElements () {
        let sku = '';
        if ($('.product-detail-keeper').length !== 0) {
            sku = $('.product-detail-keeper').data('pid');
        } else if ($('.product-quickview').length !== 0) {
            sku = $('.product-quickview').data('pid');
        }
        if (sku) {
            sku.replace(/%20/g, ' ');
        }

        return sku;
    }

    getFormattedSkuAndColor (data) {
        let color = $(data).children('span').data('attr-value');
        let sku = this.getSkuFromHtmlElements();

        sku = sku.trim().replace(/\s+/g, '_');
        let productId = sku.split('_')[0].trim();

        if (sku.toLowerCase().indexOf('color') !== -1) {
            sku = productId + '_' + color;
            return { sku, color };
        }

        let size = $('.js-selected-size').first().text().trim();

        if ($('.page').data('action') === 'Cart-Show' && !size) {
            size = $('.custom-select option:selected').text().trim();
            sku = productId + '_' + color + '_' + size;
            return { sku, color };
        }

        sku = productId + '_' + color + '_' + size;
        return { sku, color };
    }

    pushProductDeailsPLPData (pid, from) {
        let container;
        if (from === 'plp') {
            container = $(".product[data-pid='" + pid + "']").find('.analytics.productListingItem');
        } else if (from === 'home') {
            container = $(".product-slide[data-pid='" + pid + "']").find('.analytics.productListingItem');
        }

        if (container.length === 0) {
            return;
        }
        let additionalDataContainer = container.find('.clickAdditionalAttributes');
        let pushData = { ...container.data(), ...additionalDataContainer.data() };

        let item = this.helper.formatProductForAnalytics(pushData);
        item.quantity = 1;
        var list = 'category';
        try {
            let URL_SP = new URLSearchParams(window.location.search);
            list = (URL_SP.get('is_LS') === 'true') ? 'live_story' : localStorage.getItem('listtype');
        } catch (e) {}
        try {
            item.index = parseInt(localStorage.getItem('lastClickedPosition')) || 0;
        } catch (e) {
            item.index = 0;
        }

        if (list === 'cart') {
            item.index = 0;
        }

        const isOrderAgainCarousel = $(container).closest('.analytics-orderAgain-cartCarousel').length > 0;
        if (isOrderAgainCarousel) {
            list = 'buy_it_again';
        }

        const isCompleteTheLookList = $(container).closest('.analytics-completeTheLook-pdpList').length > 0;
        if (isCompleteTheLookList) {
            list = 'match_with';
        }

        const isCompleteThePromoList = $(container).closest('.analytics-completeThePromo-pdpList').length > 0;
        if (isCompleteThePromoList) {
            list = 'complete_the_promo';
        }

        item.item_list_name = list || 'not_available';
        item.item_list_id = this.helper.getListId();

        let pushObject = {
            'event': 'view_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': item.item_list_name,
                'item_list_id': item.item_list_id,
                'items': [item]
            }
        };

        this.push({ecommerce: null});
        this.push(pushObject);
    }

    // Header Impressions
    prepareHeaderObservers () {
        var _self = this;

        $('.analytics-menu-item-level-1').on('click', function (e) {
            let itemClicked = _self.helper.formatString($(e.currentTarget).data('analytics-name').split('_')[1]);
            _self.quickImpressionSender.pushMenuItemsOnTopLeftInteraction(itemClicked);
        });

        $('.analytic-header-icon, button.search-toggler').on('click', function (e) {
            _self.quickImpressionSender.pushHeaderClickInteractionFor($(this).data('analytic-name') || 'search');
        });

        // Search
        let searchObject = $('.site-search');
        if (searchObject.length) {
            searchObject.find('form').submit(function (e) {
                let searchTerm = $('.site-search form .search-field').val();
                if (!searchTerm && $('.site-search form .search-field').length > 1) {
                    searchTerm = $('.site-search form .search-field').eq(1).val();
                }
                _self.quickImpressionSender.pushSearchInteraction(searchTerm);
            });
        }
    }

    // Menu
    prepareMenuObservers () {
        var _self = this;
        let items = $('.analytics-menu-item-level-2');

        if (items.length === 0) {
            return;
        }

        items.on('click', function (e) {
            if ($(e.currentTarget).hasClass('active')) {
                return;
            }
            let item = $(e.currentTarget).data('analytics-name');
            item = _self.helper.formatString(item);
            let categoryGender = $(e.currentTarget).parent().data('menu-second-level-category-id');
            categoryGender = _self.helper.formatString(categoryGender);
            categoryGender = _self.helper.getTopLevelCategoryGender(categoryGender);

            _self.quickImpressionSender.pushMenuItemClickInteractionFor(item, categoryGender, 'second_level');
        });

        $('body').on('click', '.tab-submenu .dropdown-item a, .tab-subsubmenu .list-item a', function (e) {
            let item = $(e.currentTarget).attr('data-analytics-category-id');
            item = _self.helper.formatString(item);
            let categoryGender = _self.helper.getTopLevelCategoryGender(item);

            _self.quickImpressionSender.pushMenuItemClickInteractionFor(item, categoryGender, 'third_level');
        });

        $('body').on('click', '.menu-banner-link', function (e) {
            let item;
            if ($(e.currentTarget).parent().hasClass('menu-banner')) {
                item = $(e.currentTarget).closest('.menu-banner').data('analytics-name');
            } else {
                item = $(e.currentTarget).closest('.tab-submenu').attr('id');
            }
            _self.quickImpressionSender.pushMenuItemClickInteractionFor(_self.helper.formatString(item), 'banner');
        });

        $('body').on('click', '.menu-item-level-2', function (e) {
            if ($(e.currentTarget).hasClass('active')) {
                return;
            }
            let id = $(e.currentTarget).attr('id');
            _self.quickImpressionSender.pushMenuItemClickInteractionFor(_self.helper.formatString(id));
        });

        // Content asset menu item click
        $('.navbar-content a').on('click', function (e) {
            let id = $(this).data('name') ? $(this).data('name') : $(e.currentTarget).text().trim();
            _self.quickImpressionSender.pushMenuContentClickInteraction(_self.helper.formatString(id));
        });

        $('body').on('click', '.analytics-menu-out-mobile a', function (e) {
            let voice = $(e.currentTarget).data('analytics-name');
            if (voice) {
                voice = _self.helper.formatString(voice);
            }
            _self.quickImpressionSender.pushOutOfMenuClickInteraction(voice);
        });
    }

    // Search Filters
    prepareSearchObservers () {
        var _self = this;
        $('body').on('search:filter', function (e, data) {
            let category = $(data.currentTarget).closest('.refinement').data('analytics-refinement-id');
            let selection = $(data.currentTarget).closest('.analytic-value-container').find('a').data('value-id');
            _self.quickImpressionSender.pushSearchFilterSelectInteraction('select', category, selection);
        });

        $('body').on('search:sort', function (e, data) {
            let orderType = $(e.target).data('id');
            _self.quickImpressionSender.pushSearchSortInteraction(orderType);
        });

        // 6.15 SEARCH - LIVE SUGGESTION RESULTS
        $('body').on('click', '.suggestions a', function (e) {
            let section = $(this).data('analytics-section');
            let word = $(this).data('analytics-phrase').replace('___', '_');
            _self.quickImpressionSender.pushSearchLiveSuggestionResults(section, word);
        });

        // 6.16 SEARCH - CLICK TO CLOSE THE SEARCH BAR
        $('body').on('click', '.closeSearch', function (e) {
            _self.quickImpressionSender.pushSearchOnCloseBtn();
        });
    }

    // Newsletter
    pushNewsletterConfirmInteraction () {
        if (window.sessionStorage.getItem('reloadNewsletterState')) {
            return;
        }
        let result = 'success';
        if (document.getElementsByClassName('js-newsletterSuccess').length < 1) {
            result = 'error';
            this.quickImpressionSender.pushNewsletterError('step_3', 'invalid_confirmation_link_or_service_error');
        }
        this.quickImpressionSender.pushNewsletterStep3(result);
        window.sessionStorage.setItem('reloadNewsletterState', true);
    }

    prepareNewsletterObservers () {
        var _self = this;

        $('body').on('click', '#submitNewsletter', function (e) {
            let result = 'success';
            let errorEmailOne = $('#newsletter-Email');
            if (!errorEmailOne.parsley().isValid() && errorEmailOne.val().length > 0) {
                result = 'error';
                _self.quickImpressionSender.pushNewsletterError('step_1', 'wrong_email');
            }
            _self.quickImpressionSender.pushNewsletterStep1('footer', result);
        });

        $('body').on('click', '.newsletter-submit', function (e) {
            let result = 'error';
            let errorPrivacy = $('#newspromotions').is(':checked');
            let errorGender = document.querySelector('#mrmrs').value;
            let errorEmail = $('#email').parsley().isValid();
            let possibleErrors = [['unselected_gender', errorGender.length > 2], ['wrong_email', !errorEmail], ['unselected_privacy', !errorPrivacy]];
            let triggeredErrors = possibleErrors.filter(e => e[1]).map(e => e[0]);
            let joinedErrors = triggeredErrors.join('_and_');
            if (errorGender.length < 2 && errorEmail && errorPrivacy) {
                result = 'success';
            } else {
                _self.quickImpressionSender.pushNewsletterError('step_2', joinedErrors);
            }
            _self.quickImpressionSender.pushNewsletterStep2(result);
        });

        $('body').on('newsletter:unsubscribe', function () {
            if (!$('#phone-number-cell').length) {
                _self.quickImpressionSender.pushNewsletterUnsubscribe();
            }
        });

        // Thank you
        if (this.helper.checkPage('newsletterconfirm')) {
            this.pushNewsletterConfirmInteraction();
        } else {
            window.sessionStorage.removeItem('reloadNewsletterState');
        }
    }

    // Contact Us
    handleContactUs () {
        var _self = this;
        $('body').on('submit', 'form.contact-form', function (e) {
            if (!e.currentTarget.checkValidity()) {
                return;
            }
            let notRobot = grecaptcha && grecaptcha.getResponse().length !== 0;
            if (notRobot) {
                _self.quickImpressionSender.pushContactUsInteraction($(e.currentTarget).find('select.contactType').val());
            }
        });
    }

    // Wishlist
    observeWishlistChanges () {
        var _self = this;
        $('body').on('wishlist:add', function (e, data) {
            _self.quickImpressionSender.pushAddToWishlistInteraction(data);
        });

        $('body').on('wishlist:remove', function (e, data) {
            let sku = decodeURIComponent(data.sku);
            _self.quickImpressionSender.pushRemoveFromWishlistInteraction(sku, data.sender);
        });
    }

    // Footer
    observeFooterChanges () {
        var _self = this;

        // Social Icons
        $('.analytic.analytic-social-icon-share').on('click', function (e) {
            let socialName = $(this).data('name');
            _self.quickImpressionSender.pushSocialClickInteractionFooter(socialName);
        });

        $('.analytic-footer-icon-text').on('click', function (e) {
            let name = _self.helper.formatString($(this).data('name'));
            _self.quickImpressionSender.pushFooterLinkClickInteraction('pre_footer', name);
        });

        $('.analytic-footer-text').on('click', function (e) {
            let name = _self.helper.formatString($(this).data('name'));
            _self.quickImpressionSender.pushFooterLinkClickInteraction('footer', name);
        });

        $('.footer .accordion-item').on('click', function (e) {
            let i = 0;
            let name;
            if ($(e.currentTarget).find('.accordion-content').css('display') !== 'none') {
                return;
            }
            while (i < $('.footer .accordion-item').length) {
                if ($(e.currentTarget)[0] === $('.footer .accordion-item').eq(i)[0]) {
                    break;
                }
                i++;
            }
            switch (i) {
            case 0:
                name = 'client_service';
                break;
            case 1:
                name = 'guide_size';
                break;
            case 2:
                name = 'corporate';
                break;
            case 3:
                name = 'legal_area';
                break;
            default:
                name = '';
                break;
            }
            _self.quickImpressionSender.pushFooterLinkClickInteraction('text', name);
        });
    }

    // Products
    observeProductChanges () {
        var _self = this;

        $('body').on('product:triggerProductDetails', function (e, data) {
            _self.pushProductDeailsPLPData(data, 'plp');
        });

        $('body').on('product:triggerProductDetailsHome', function (e, data) {
            _self.pushProductDeailsPLPData(data, 'home');
        });

        $('body').on('product:didChangeColorPLP', function (e, data) {
            let color = data.sku.replace('_color_', ' ').split(' ')[1];
            _self.quickImpressionSender.pushProductChangeColorInteraction(color, data.sku);
        });

        $('body').on('product:didChangeColor', function (e, data) {
            const { sku, color } = _self.getFormattedSkuAndColor(data);
            const type = $(data).find('.tooltip-sale-wrapper').length > 0 ? 'on_sale' : 'standard';
            _self.quickImpressionSender.pushProductChangeColor(color, sku, type);
        });

        $('body').on('product:didChangeSize', function (e, size) {
            let sku = _self.getSkuFromHtmlElements();
            _self.quickImpressionSender.pushProductChangeSizeInteraction(size, sku);
        });

        $('body').on('click touchstart', '.analytics-product-image', function (e) {
            var photoType = 'still_life';
            var imgLink = $(this).find('img').attr('src') || '';
            if (imgLink && imgLink.indexOf('wear') > -1) {
                photoType = 'weared';
            }
            var sku = $(this).parents('div.product-wrapper').data('pid') || '';
            sku = decodeURIComponent(sku);
            _self.quickImpressionSender.pushProductImageClickInteraction(photoType, sku);
        });

        // '.size-guide a' - sfcc implementation of size guide
        // '.vfr__button--clean' - sizebay implementation of size guide 
        $('body').on('click', '.js-open-find-your-size-tool, .size-guide a, .vfr__button--clean', function (e) {
            let sku = _self.helper.getFormatSku($('.product-detail').data('pid'));
            _self.quickImpressionSender.pushGuidesClickInteraction('size_guide', 'product_page', sku);
        });

        $('.menu-fourth-column .menu-guide .menu-guide-link').on('click', function (e) {
            let sku = '';
            _self.quickImpressionSender.pushGuidesClickInteraction('size_guide', 'menu', sku);
        });

        $('body').on('click', '.js-match-with', function () {
            let sku = _self.helper.getFormatSku($('.product-detail').data('pid'));
            let label = $('.js-match-with .js-promo-text.hidden').length ? 'match_with' : 'complete_the_promo';
            _self.quickImpressionSender.pushProductDetailPageMatchWithCTAs(label, sku);
        });

        $('body').on('product:find_in_store_soldout', function (_, target) {
            var sku;
            if ($('.page').data('action') === 'Product-Show') {
                sku = $('.product-detail.container').data('master-pid');
            } else if ($('.page').data('action') === 'Search-Show') {
                sku = $(target).closest('.product').find('.analytics.productListingItem .clickAdditionalAttributes').data('item_sfcc');
            } else {
                return;
            }
            _self.quickImpressionSender.pushFindInStoreSoldoutInteraction(sku);
        });

        $('body').on('find-in-store-size-select-btn:click', function (_, data) {
            var size = $(data.currentTarget).data('attr-value');
            var sku;
            var name;
            var isSoldout;
            if ($('.page').data('action') === 'Product-Show') {
                sku = $('.product-detail.container').data('master-pid');
                name = _self.helper.formatString($('.analytics.product').data('name'));
                isSoldout = $('.product-detail.container').hasClass('is-soldout');
            } else if ($('.page').data('action') === 'Search-Show') {
                sku = $(data.currentTarget).data('sku');
                name = _self.helper.formatString($(data.currentTarget).data('name'));
                isSoldout = true;
            } else {
                return;
            }
            let isComingSoon = $('.product-content-size input[type="radio"][data-iscomingsoon="true"]').length > 0;
            let sizeNotAbailableNotifyMe = $('.product-content-size input[type="radio"][data-attr-value="' + size + '"]').closest('label').find('span.notifyMe').length > 0;
            let sizeNotAvailableNoNotifyMe = $('.product-content-size input[type="radio"][data-attr-value="' + size + '"]').prop('disabled');
            let notAvailable = isSoldout || isComingSoon || sizeNotAbailableNotifyMe || sizeNotAvailableNoNotifyMe;
            _self.quickImpressionSender.pushProductCheckAvailabilitySizeClickInteraction(sku, size, name, notAvailable);
        });

        $('body').on('observeVideoTracking', function () {
            _self.observeVideoTracking();
        });

        $('body').on('bonusProduct:quickviewOpen', function (e, data) {
            if (data.products.length === 1) {
                const $container = $(data.container).find('.analytics.productListingItem');
                _self.helper.setBonusProductData($container, 0);
                _self.pushViewItem($container);
            }
        });

        $('body').on('bonusProduct:productSelected', function (e, data) {
            const $container = $(data.container).find('.analytics.productListingItem');
            _self.helper.setBonusProductData($container, $container.data('index'));
            _self.pushViewItem($container);
        });

        if ($('.analytics.product').length === 0) {
            return;
        }

        $('body').on('product:afterAttributeSelect', function (e, data) {
            _self.quickImpressionSender.pushNewProduct(data);
        });

        $('body').on('click', '.productImageCarouselItem', function (e, data) {
            var sku = $(e.currentTarget).closest('.product-detail').data('variant-pid');
            _self.quickImpressionSender.pushProductZoomInteraction(
                _self.helper.getFormatSku(decodeURI(sku))
            );
        });

        $('body').on('product:changeZoomImage', function (e, data) {
            _self.quickImpressionSender.pushProductImageClickInteraction(data.photoType, decodeURIComponent(data.sku));
        });

        $('body').on('product:moreInfoToggle', function (e, data) {
            _self.quickImpressionSender.pushProductInformationalMenuChange(data);
        });

        $('body').on('product:calculateSize', function (e, data) {
            let sku = _self.helper.getFormatSku($('.product-detail').data('pid'));
            _self.quickImpressionSender.pushFindYourSizeClickInteraction(sku);
        });

        $('body').on('analytics:openCustomizationModal', function (e) {
            _self.quickImpressionSender.pushCustomizeProductInteraction(
                _self.helper.formatString($('.analytics.product').data('name')),
                _self.helper.getFormatSku($('.container.product-detail-keeper').data('pid'))
            );
        });

        $('body').on('analytics:customizeProdActions', function (e, action) {
            _self.quickImpressionSender.pushCustomizeProductActionsInteraction(action, _self.helper.getFormatSku($('.container.product-detail-keeper').data('pid')));
        });

        $('body').on('click', '.analytics-customizeProd-actions', function (e) {
            _self.quickImpressionSender.pushCustomizeProductActionsInteraction(
                $(e.currentTarget).data('analytics-action'),
                _self.helper.getFormatSku($('.product-detail-keeper').data('pid'))
            );
        });

        $('body').on('mouseover', '.fnPersModal-footer-priceWrp span.icon-black-helper', function (e) {
            _self.quickImpressionSender.pushCustomizeProductActionsInteraction(
                'tooltip_click',
                _self.helper.getFormatSku($('.product-detail-keeper').data('pid'))
            );
        });
        // 7.146 FIND OUT MORE (ONLY FRANCE COUNTRY)
        $('body').on('click', '.js-analytics-traceability', function (e) {
            _self.quickImpressionSender.pushFindOutMoreTraceabilityInteraction();
        });
    }

    observeVideoTracking () {
        var _self = this;
        var divisor = 25;
        var videoPercentage = {};
        var videoName;
        var autoplayFired = {};
        function eventHandler (e) {
            switch (e.type) {
            case 'timeupdate':
                videoPercentage[e.target.id].current = Math.round(e.target.currentTime);
                var percentage = Math.floor(100 * videoPercentage[e.target.id].current / e.target.duration);
                for (let i in videoPercentage[e.target.id]._progress_markers) {
                    if (percentage >= i && i > videoPercentage[e.target.id].greatest_marker) {
                        videoPercentage[e.target.id].greatest_marker = i;
                    }
                }
                if (videoPercentage[e.target.id].greatest_marker && !videoPercentage[e.target.id]._progress_markers[videoPercentage[e.target.id].greatest_marker]) {
                    videoPercentage[e.target.id]._progress_markers[videoPercentage[e.target.id].greatest_marker] = true;

                    let actualPercentage = videoPercentage[e.target.id].greatest_marker;
                    videoName = _self.helper.formatString(decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]));
                    if (actualPercentage === '25') {
                        _self.quickImpressionSender.pushPercentage25VideoInteraction(videoName);
                    } else if (actualPercentage === '50') {
                        _self.quickImpressionSender.pushPercentage50VideoInteraction(videoName);
                    } else if (actualPercentage === '75') {
                        _self.quickImpressionSender.pushPercentage75VideoInteraction(videoName);
                    }
                }
                break;
            case 'play':
                videoName = _self.helper.formatString(decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]));
                _self.quickImpressionSender.pushPlayVideoInteraction(videoName);
                break;
            case 'pause':
                videoName = _self.helper.formatString(decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]));
                _self.quickImpressionSender.pushPauseVideoInteraction(videoName);
                break;
            case 'ended':
                videoName = _self.helper.formatString(decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]));
                _self.quickImpressionSender.pushFullVideoInteraction(videoName);
                break;
            default:
                break;
            }
        }
        function eventHandlerAutoPlay (e) {
            switch (e.type) {
            case 'play':
                if (!autoplayFired[e.target.id]) {
                    autoplayFired[e.target.id] = true;
                    videoName = _self.helper.formatString(decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1]));
                    _self.quickImpressionSender.pushAutoPlayVideoInteraction(videoName);
                }
                break;
            default:
                break;
            }
        }

        var videos = document.getElementsByTagName('video');
        for (var i = 0; i < videos.length; i++) {
            var videoTagId;
            if (!videos[i].getAttribute('id')) {
                videoTagId = 'html5_video_' + Math.random().toString(36).slice(2);
                videos[i].setAttribute('id', videoTagId);
            } else {
                videoTagId = videos[i].getAttribute('id');
            }
            videoPercentage[videoTagId] = {};
            videoPercentage[videoTagId].greatest_marker = 0;
            videoPercentage[videoTagId]._progress_markers = {};
            for (let j = 0; j < 100; j++) {
                videoPercentage[videoTagId].progress_point = divisor * Math.floor(j / divisor);
                videoPercentage[videoTagId]._progress_markers[videoPercentage[videoTagId].progress_point] = false;
            }
            videoPercentage[videoTagId].current = 0;
            if (videos[i].hasAttribute('autoplay')) {
                videos[i].addEventListener('play', eventHandlerAutoPlay, false);
            } else {
                videos[i].addEventListener('play', eventHandler, false);
                videos[i].addEventListener('pause', eventHandler, false);
                videos[i].addEventListener('ended', eventHandler, false);
                videos[i].addEventListener('ended', function () {
                    videoPercentage[videoTagId] = {};
                    videoPercentage[videoTagId].greatest_marker = 0;
                    videoPercentage[videoTagId]._progress_markers = {};
                    for (let j = 0; j < 100; j++) {
                        videoPercentage[videoTagId].progress_point = divisor * Math.floor(j / divisor);
                        videoPercentage[videoTagId]._progress_markers[videoPercentage[videoTagId].progress_point] = false;
                    }
                    videoPercentage[videoTagId].current = 0;
                }, false);
                videos[i].addEventListener('timeupdate', eventHandler, false);
            }
            if (videos[i].closest('.videoTopBanner')) {
                let currentVideo = videos[i];
                $(document).on('click', '.clickController, .clickControllerMobile', function () {
                    if (!currentVideo.paused) {
                        let videoName = _self.helper.formatString(decodeURIComponent(currentVideo.currentSrc.split('/')[currentVideo.currentSrc.split('/').length - 1]));
                        _self.quickImpressionSender.pushPauseVideoInteraction(videoName);
                    }
                });
            }
        }
    }

    // Refinements
    prepareRefinementsObservers () {
        var _self = this;

        $('body').on('click', '.analytics-refinement', function (e) {
            let clicked = $(this).data('special-refinement-value') || '';
            if (clicked) {
                clicked = clicked.split('_');
                let category = _self.helper.formatString(clicked[clicked.length - 2]);
                let selection = _self.helper.formatString(clicked[clicked.length - 1]);

                _self.quickImpressionSender.pushSearchFilterSelectInteraction('apply_a_category_filter', category, selection);
            }
        });

        $('body').on('afterChange', '.pdpCarousel__slider.slick-slider, .quickviewCarousel__slider.slick-slider', function (e) {
            if ($(e.currentTarget).parents('.theMostPopularContainer').length !== 0) {
                return;
            }
            var skuClicked = $('.product-detail-keeper').data('pid');
            if (skuClicked && !Foundation.MediaQuery.atLeast('medium')) {
                _self.quickImpressionSender.pushChangeImageInteraction(skuClicked.replace(/%20/g, ' '));
            };
        });

        $('body').on('click', '.pdpCarousel__slider-container .slick-arrow, .carousel-inner-zoom .arrow-zoom', function (e) {
            var skuClicked = $('.product-detail-keeper').data('pid');
            if (skuClicked && Foundation.MediaQuery.atLeast('medium')) {
                _self.quickImpressionSender.pushChangeImageInteraction(skuClicked.replace(/%20/g, ' '));
            };
        });

        $('body').on('click', '.need-help-box .accordion-title', function (e) {
            if (!($(e.currentTarget).closest('.accordion-item').hasClass('active'))) {
                return;
            }
            let index = $('.need-help-box .accordion-title').index(this);
            let labelClicked = '';

            switch (index) {
            case 0:
                labelClicked = 'discover_all_shipping_methods';
                break;
            case 1:
                labelClicked = 'free_returns';
                break;
            case 2:
                labelClicked = 'safe_payments';
                break;
            default:
                labelClicked = '';
                break;
            }
            _self.quickImpressionSender.pushfaqInteraction(labelClicked);
        });

        $('body').on('click', '.continue-shopping-link', function (e) {
            _self.quickImpressionSender.pushContinueShoppingInteraction();
        });
    }

    observeSoldOutPopupChanges () {
        var _self = this;

        $('body').on('soldout:notify', function (e) {
            let product = $('.analytics.product');
            if (product.length === 0) {
                product = $('div.product-wrapper').find('.analytics.productListingItem');
            }
            let productName = _self.helper.formatNameForAnalytics(product.data('item_name'));
            let size = $('[data-attr="size"] input.clicked-size').attr('data-attr-value');
            let sku = _self.generateAnalyticsSku(true);
            _self.quickImpressionSender.pushNotifyMeSoldOutSize(productName, size, sku);
        });

        $('body').on('soldout:cancel', function (e, data) {
            _self.quickImpressionSender.pushCancelSoldOutSize(data.callToAction, data.sku);
        });
    }

    // ScalaPay/Klarna modal interaction
    prepareScalaPayKlarnaObservers () {
        var _self = this;

        $('body').on('scalaPay:openModal', function (e, where) {
            _self.quickImpressionSender.pushScalaPayAndKlarnaModalsInteraction('scalapay', where);
        });

        $('body').on('klarnaPay:openModal', function (e, where) {
            _self.quickImpressionSender.pushScalaPayAndKlarnaModalsInteraction('klarna', 'product_page');
        });
    }

    prepareGiftcardObservers () {
        var _self = this;

        $('body').on('giftcardCheckBalance', function (e, data) {
            _self.quickImpressionSender.giftcardCheckBalance(data);
        });

        $('body').on('giftcardApply', function (e, data) {
            _self.quickImpressionSender.giftcardApply(data);
        });

        $('body').on('giftcardRemove', function (e, data) {
            _self.quickImpressionSender.giftcardRemove(data);
        });

        $('.button-balance').on('click', function (e) {
            $(this).data('clicked', true);
        });
    }

    observeOrderChanges () {
        var _self = this;

        $('body').on('order:cancel', function (e, data) {
            if ($('.js-order-cancellation-ok').css('display') === 'none') {
                _self.quickImpressionSender.pushCancelYourOrderInteraction(data.orderId);
            }
        });

        $('body').on('order:cancelInteraction', function (e, data) {
            let action = _self.helper.formatString(data.action);
            if ($('.js-order-cancellation-ok').css('display') === 'none') {
                _self.quickImpressionSender.pushCancelYourOrderInteractionAction(data.orderId, action);
            }
        });
    }

    // Made In
    observeMadeInClick () {
        var _self = this;

        $('body').on('click', '.js-analytics-made-in', function (e) {
            let event = $(this).data('fabric').split(' ').join('_').toLowerCase();
            let plant = event.split(',').join('');
            let sku = decodeURIComponent($('.product-detail').data('pid'));
            sku = _self.helper.getFormatSku(sku);

            let pushObject = {
                'event': 'GAevent',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'eventID': '78',
                'eventname': 'made_in',
                'action': 'click_word',
                'text': plant,
                'product_id': sku
            };

            _self.push(pushObject);
        });

        $('body').on('click', '.js-analytics-modal-cta', function (e) {
            let action = $(this).data('action').split(' ').join('_').toLowerCase();
            let fabric = $(this).data('fabric').split(' ').join('_').toLowerCase();
            let plant = fabric.split(',').join('');

            let pushObject = {
                'event': 'GAevent',
                'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
                'eventID': '79',
                'eventname': 'made_in',
                'action': action,
                'text': plant
            };

            _self.push(pushObject);
        });

        $('body').on('click', '.read-more', function (e) {
            _self.quickImpressionSender.pushReadTheWholeInterview();
        });

        $('body').on('click', '.plant-box', function (e) {
            let plant = e.currentTarget.innerText.split('\n').reverse().join('_').toLowerCase();
            _self.quickImpressionSender.pushMadeInPlantInteraction(plant);
        });
    }

    // Smart Gift
    handleSmartGift () {
        var _self = this;
        $('body').on('analytics:addSmartGift', function (e, data) {
            var formattedSku = _self.helper.getFormatSku(data.sku);
            _self.quickImpressionSender.pushSmartGift(formattedSku, data.name);
        });
        $('body').on('analytics:smartGiftBasketButtons', function (e, data) {
            var formattedSkus = _self.helper.formatSkus(data.skus);
            _self.quickImpressionSender.pushSmartGiftBasketInteraction106(data.action, formattedSkus, data.quantity);
        });
        $('body').on('analytics:smartGiftBasketRemoveProduct', function (e, data) {
            var productName = _self.helper.formatString(data.productName);
            var formattedSku = _self.helper.getFormatSku(data.sku);
            _self.quickImpressionSender.pushSmartGiftBasketInteraction107(productName, formattedSku);
        });
        $('body').on('analytics:smartGiftBasketIcon', function () {
            let location = '';
            if ($('.page').data('action') === 'Product-Show') {
                location = 'product_page';
            } else {
                location = 'listing_page';
            }
            _self.quickImpressionSender.pushSmartGiftBasketInteraction108(location);
        });
        $('body').on('analytics:smartGiftMoreInfo', function () {
            _self.quickImpressionSender.pushSmartGiftMoreInfo();
        });
    }

    handleRatingAndReviewsPdp () {
        const _self = this;
        $('body').on('analytics:ratingAndReviewsPdp', function (e, data) {
            let sku = _self.generateAnalyticsSku();
            _self.quickImpressionSender.pushRatingAndReviewsInteraction105(data.action, data.word, sku);
        });
    }

    handleRatingAndReviewsForm () {
        const _self = this;
        $('body').on('analytics:ratingAndReviewsFormGuidelines', function () {
            let productName = $('.tingle-modal #review-popup .product-name').data('analytics-name');
            let formattedName = _self.helper.formatNameForAnalytics(productName);
            let sku = $('.tingle-modal #review-popup #reviewSku').val();
            let formattedSku = _self.helper.getFormatSku(sku);
            _self.quickImpressionSender.pushRatingAndReviewsInteraction106(formattedName, formattedSku);
        });
        $('body').on('analytics:ratingAndReviewsFormSubmit', function () {
            let overallRating = $('.tingle-modal #review-popup .stars .review-star-wrapper.filled').length;
            let sizeRating = $('.tingle-modal #review-popup .review-radio-size:checked').data('analytics-name');
            let qualityRating = $('.tingle-modal #review-popup .review-radio-price:checked').data('analytics-name');
            let comfortabilityRating = $('.tingle-modal #review-popup .review-radio-comfort:checked').data('analytics-name');
            let sku = $('.tingle-modal #review-popup #reviewSku').val();
            let formattedSku = _self.helper.getFormatSku(sku);
            _self.quickImpressionSender.pushRatingAndReviewsInteraction101(overallRating, sizeRating, qualityRating, comfortabilityRating, formattedSku);
        });
        $('body').on('analytics:ratingAndReviewsFormSubmitted', function (e, data) {
            _self.quickImpressionSender.pushRatingAndReviewsInteraction108(data.action);
        });

        $('body').on('click', '.analytics-reviews-btn', function (e) {
            let category = $('.analytics.product').data('item_category').split('/')[2];
            let sku = _self.helper.getFormatSku(decodeURI($('.product-detail').data('variant-pid')));
            _self.quickImpressionSender.pushReviewsButtonOnPdpInteraction(category, sku);
        });

        $('body').on('click', '#ratingsReviewsSection .tt-c-review-toolbar button.tt-o-button', function (e) {
            let action = $(e.currentTarget).find('.tt-c-review-toolbar__likes-number').length ? 'like' : 'dislike';
            let stars = $(e.currentTarget).closest('.tt-c-review').find('.tt-o-icon--star--full').length;
            let sku = _self.helper.getFormatSku(decodeURI($('.product-detail').data('variant-pid')));
            _self.quickImpressionSender.pushLikeDislikeToReview(action, stars + '_stars', sku);
        });
    }

    prepareNeedHelpObservers () {
        var _self = this;

        let pageType = _self.helperData.pageType;

        $('body').on('click', '#esw-fab', function (e) {
            if ($(e.currentTarget).attr('aria-expanded') === 'true') {
                _self.quickImpressionSender.pushBubbleClickInteraction(pageType);
            }
        });

        $('body').on('click', '.js-bubble-open', function (e) {
            _self.quickImpressionSender.pushBubbleClickInteraction(pageType);
        });

        $('body').on('click', '.bubble-service-list a, .help-cell a', function (e) {
            let selection = '';
            let $target = $(e.currentTarget);
            if ($target.hasClass('js-live-chat')) {
                selection = 'chat';
            } else if ($target.hasClass('js-bubble-call')) {
                selection = 'call_number';
            } else if ($target.hasClass('js-web-form-request')) {
                selection = 'send_us_email';
            } else if ($target.hasClass('js-bubble-return')) {
                selection = 'follow_your_order_or_return';
            } else if ($target.hasClass('js-bubble-leave-feedback')) {
                selection = 'leave_a_feedback';
            }
            if (!selection) {
                let ref = $target.attr('href');
                if (ref && ref.indexOf('contactform') !== -1) {
                    selection = 'send_us_email';
                } else {
                    selection = 'leave_a_feedback';
                }
            }
            _self.quickImpressionSender.pushESWInteraction(selection, pageType);
        });

        $('body').on('click', '.cta-embeddedserviceconfig', function () {
            _self.quickImpressionSender.pushESWInteraction('chat', pageType);
        });

        $('body').on('click', '.cta-phone', function () {
            _self.quickImpressionSender.pushESWInteraction('call_number', pageType);
        });

        $('body').on('click', '.cta-customurl', function (e) {
            if ($(e.currentTarget).find('.cta-link-customurl').attr('href').includes('contactform')) {
                _self.quickImpressionSender.pushESWInteraction('send_an_email', pageType);
            } else if ($(e.currentTarget).find('.cta-link-customurl').attr('href').includes('orderstatus')) {
                _self.quickImpressionSender.pushESWInteraction('follow_your_order_or_return', pageType);
            } else if ($(e.currentTarget).find('.cta-link-customurl').attr('href').includes('general-info')) {
                _self.quickImpressionSender.pushESWInteraction('leave_a_feedback', pageType);
            }
        });
        $('body').on('analytics:privacyPopUP', function (e, data) {
            var privacyNews = data.privacyNews;
            var privacyCustomNews = data.privacyCustomNews;
            _self.quickImpressionSender.pushPrivacyPolicyPopUP(data.action, privacyNews, privacyCustomNews);
        });
    }

    prepareEcoChoiceObservers () {
        var _self = this;

        let user = 'guest';
        if (_self.helperData.frequentlyUser) {
            user = 'frequently_user';
        }

        let refundPageselector = '.js-label-refund .icon-info-black.eco-green';
        refundPageselector += ',.return-in-store-enabled .icon-info-black.eco-green';
        refundPageselector += ',#returnMethodDiv .icon-info-black.eco-green';
        $('body').on('click', refundPageselector, function (e, data) {
            _self.quickImpressionSender.pushEcoChoiceClick('refund', user);
        });

        $('body').on('click', '.tingle-modal.express-button-modal .icon-info-black.eco-green', function (e, data) {
            _self.quickImpressionSender.pushEcoChoiceClick('popup', user);
        });

        $('body').on('click', '.shipping-section .icon-info-black.eco-green', function (e, data) {
            _self.quickImpressionSender.pushEcoChoiceClick('checkout', user);
        });
    }

    prepareTrackYourOrderObservers () {
        var _self = this;

        $('body').on('submit', '#form-order-status', function (e) {
            let transactionID = $(e.target).find('#input-order-status-number').val();
            _self.quickImpressionSender.pushTrackYourOrder(transactionID);
        });
    }

    preparePersonalAreaNavigationOrderSectionObservers () {
        var _self = this;

        $('body').on('click', '.return-info-box a, .shipping-button, .return-button, .cta-analytics, .analytics-order-moreInfo', function (e) {
            let ctaName;
            if ($(e.currentTarget).hasClass('shipping-button')) {
                ctaName = ($(this).find('span').data('analytic-name'));
            } else {
                ctaName = ($(this).data('analytic-name'));
            }
            _self.quickImpressionSender.pushPersonalAreaNavigationOrderSection(ctaName);
        });
    }

    prepareQuizBraObservers () {
        var _self = this;

        $('body').on('click', '.start-quiz-button, .retake-test', function (e) {
            let pageType = '';
            let quizButton = '';
            if ($('.page').data('action') === 'Quiz-InitialPage') {
                pageType = 'help_me_choose';
            } else if ($('.page').data('action') === 'Search-Show') {
                pageType = 'quiz_thankyou_page';
            } else {
                pageType = 'homepage';
            }
            if ($(e.currentTarget).hasClass('retake-test')) {
                quizButton = 'take_the_quiz_again';
            } else {
                quizButton = 'start_the_quiz';
            }
            _self.quickImpressionSender.pushStartTheQuiz(quizButton, pageType);
        });
        $('body').on('click', '.quiz-bra-initial-page.button-group button', function (e) {
            let adviceType = '';
            if ($(this).hasClass('shoulder-pads')) {
                adviceType = $(this).attr('name');
            } else if ($(this).hasClass('cups')) {
                adviceType = $(this).attr('name');
            } else if ($(this).hasClass('underband')) {
                adviceType = $(this).attr('name');
            } else if ($(this).hasClass('shape')) {
                adviceType = $(this).attr('name');
            }
            _self.quickImpressionSender.pushOurAdvice(adviceType);
        });
        $('body').on('click', '#step_1_answers button', function (e) {
            let reasonChosen = '';
            if ($(this).hasClass('answer_1')) {
                reasonChosen = 'i_want_to_find_my_ideal_size';
            } else if ($(this).hasClass('answer_2')) {
                reasonChosen = 'i_want_to_replace_my_old_bra';
            } else if ($(this).hasClass('answer_3')) {
                reasonChosen = 'i_have_to_buy_my_first_bra';
            } else if ($(this).hasClass('answer_4')) {
                reasonChosen = 'simply_curiosity';
            }
            _self.quickImpressionSender.pushReasonForBraQuiz(reasonChosen);
        });

        $('body').on('click', '.step_2_answers_row_wrapper button, .alternative_flow', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('alternative_flow')) {
                answerChoosen = 'i_dont_know_my_size';
            } else {
                answerChoosen = $(this).data('value');
            }
            _self.quickImpressionSender.pushSizeForBraQuiz('underbust_bend', answerChoosen);
        });
        $('body').on('click', '.step_3_answers_row_wrapper button, .alternative_flow', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('alternative_flow')) {
                answerChoosen = 'i_dont_know_my_size';
            } else {
                answerChoosen = $(this).data('value');
            }
            _self.quickImpressionSender.pushSizeForBraQuiz('cup', answerChoosen);
        });

        $('body').on('click', '#step_4_answers button', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('answer_1')) {
                answerChoosen = 'yes_its_too_tight';
            } else if ($(this).hasClass('answer_2')) {
                answerChoosen = 'yes_its_too_wide';
            } else if ($(this).hasClass('answer_3')) {
                answerChoosen = 'no_it_adapts_properly_to_the_body';
            }
            _self.quickImpressionSender.pushUnderbustChangeForBraQuiz(answerChoosen);
        });

        $('body').on('click', '#step_5_answers button', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('answer_1')) {
                answerChoosen = 'yes_they_are_too_big';
            } else if ($(this).hasClass('answer_2')) {
                answerChoosen = 'yes_they_are_too_small';
            } else if ($(this).hasClass('answer_3')) {
                answerChoosen = 'no_they_fit_well_on_my_breast';
            }
            _self.quickImpressionSender.pushCupChangeForBraQuiz(answerChoosen);
        });

        $('body').on('click', '#step_6_answers button', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('answer_1')) {
                answerChoosen = 'basic';
            } else if ($(this).hasClass('answer_2')) {
                answerChoosen = 'refined';
            } else if ($(this).hasClass('answer_3')) {
                answerChoosen = 'sporty_and_functional';
            } else {
                answerChoosen = 'no_preferences';
            }
            _self.quickImpressionSender.pushStyleForBraQuiz(answerChoosen);
        });

        $('body').on('click', '#step_7_answers button', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('answer_1')) {
                answerChoosen = 'natural';
            } else if ($(this).hasClass('answer_2')) {
                answerChoosen = 'rounded';
            } else if ($(this).hasClass('answer_3')) {
                answerChoosen = 'voluminous';
            } else if ($(this).hasClass('answer_4')) {
                answerChoosen = 'extra_voluminous';
            } else {
                answerChoosen = 'no_preferences';
            }
            _self.quickImpressionSender.pushEffectForBraQuiz(answerChoosen);
        });

        $('body').on('click', '#step_8_answers button', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('answer_1')) {
                answerChoosen = 'with_underwire_for_better_support';
            } else if ($(this).hasClass('answer_2')) {
                answerChoosen = 'without_underwire_for_greater_comfort';
            } else {
                answerChoosen = 'no_preferences';
            }
            _self.quickImpressionSender.pushTypeForBraQuiz(answerChoosen);
        });

        $('body').on('click', '#step_9_answers button', function (e) {
            var answerChoosen = '';
            if ($(this).hasClass('answer_1')) {
                answerChoosen = 'cotton';
            } else if ($(this).hasClass('answer_2')) {
                answerChoosen = 'lace';
            } else if ($(this).hasClass('answer_3')) {
                answerChoosen = 'microfiber';
            } else if ($(this).hasClass('answer_4')) {
                answerChoosen = 'other_fabrics';
            } else {
                answerChoosen = 'no_preferences';
            }
            _self.quickImpressionSender.pushFabricForBraQuiz(answerChoosen);
        });
        document.addEventListener('unhideStepTen', function () {
            var answerChoosen = '';
            if (window.sessionStorage.noResultPageRefresh.includes('NR')) {
                answerChoosen = 'no_result';
            } else {
                answerChoosen = $('.recommended_bra_size').text();
            }
            _self.quickImpressionSender.pushThankYouForBraQuiz(answerChoosen);
        });
    }

    pushViewItem ($container, index = 0, itemListName = '', itemListId = '') {
        const additionalDataContainer = $container.find('.clickAdditionalAttributes');
        const pushData = { ...$container.data(), ...additionalDataContainer.data() };

        if (index) {
            pushData.index = index;
        }
        if (itemListName) {
            pushData.item_list_name = itemListName;
        }
        if (itemListId) {
            pushData.item_list_id = itemListId;
        }

        const product = this.helper.formatProductForAnalytics(pushData);

        this.helper.storeGtmData({
            item_id: pushData.item_id,
            item_variant: pushData.item_variant,
            item_list_name: product.item_list_name,
            item_list_id: product.item_list_id,
            index: product.index
        });

        let pushObject = {
            'event': 'view_item',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'currency': this.helperData.currency,
                'item_list_name': product.item_list_name,
                'item_list_id': product.item_list_id,
                'items': [product]
            }
        };
        this.push({ecommerce: null});
        this.push(pushObject);
    }
    cookiePolicyObservers () {
        var _self = this;

        $('body').on('click', '.ot-close-link', function () {
            _self.quickImpressionSender.pushCookieBanner('close');
        });

        $('body').on('click', '#onetrust-policy-text a:not(.ot-sdk-show-settings)', function () {
            _self.quickImpressionSender.pushCookieBanner('cookie_policy');
        });

        $('body').on('click', '.ot-sdk-show-settings', function () {
            _self.quickImpressionSender.pushCookieBanner('cookie_settings');
        });

        $('body').on('click', '#onetrust-accept-btn-handler', function () {
            _self.quickImpressionSender.pushCookieBanner('accept_all_cookies');
        });
    }

    replaceTagsPrivacyConsentModal () {
        const _self = this;
        const targetNode = document.body;
        const config = { childList: true, subtree: true };

        const callback = function (mutationsList, observer) {
            let isBannerChanged = false;
            let isPrivacyConsentChanged = false;

            for (const mutation of mutationsList) {
                if (mutation.type !== 'childList') {
                    continue;
                }

                const modalPrivacyConsent = $('#onetrust-pc-sdk');
                if (modalPrivacyConsent.length) {
                    modalPrivacyConsent.find('h1, h2, h4, h5, h6').each((idx, element) => {
                        _self.replaceElementIfExists($(element));
                    });
                    isPrivacyConsentChanged = true;
                }

                const modalBanner = $('#onetrust-banner-sdk');
                if (modalBanner.length) {
                    modalBanner.find('h1, h2, h3, h4, h5, h6').each((idx, element) => {
                        _self.replaceElementIfExists($(element));
                    });
                    isBannerChanged = true;
                }
            }

            if (isBannerChanged && isPrivacyConsentChanged) {
                observer.disconnect();
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    replaceElementIfExists (oldElement, newTag = 'div') {
        if (oldElement && oldElement.length) {
            const newElement = $(`<${newTag}>`);
            newElement.html(oldElement.html());

            $.each(oldElement.prop('attributes'), function () {
                $(newElement).attr(this.name, this.value);
            });

            oldElement.replaceWith(newElement);
        }
    }

    prepareOrderAgainObservers () {
        const _self = this;

        $('body').on('analytics:orderAgainModalOpened', function (e, data) {
            const target = 'target' in data ? data.target : null;
            const index = 'index' in data ? data.index : 0;
            const itemListName = 'buy_it_again';
            const itemListId = $('.page').data('action') === 'Cart-Show' ? 'cart' : 'my_orders_and_returns';
            if (!target) {
                return;
            }
            _self.pushViewItem(target, index, itemListName, itemListId);
        });

        $('body').on('analytics:orderAgainAfterAttributeSelect', function (e, data) {
            _self.quickImpressionSender.pushNewProduct(data);
        });
    }
}

const manager = new AnalyticsManager();
module.exports = manager;
